import { useAxios } from 'api/axios';
import { EndPoint } from 'data/endpoint';
import useClientStore from 'store/client';
import { ApiResponse } from 'types/api/response';
import { Client } from 'types/client/client.type';

const useClient = () => {
  const { api } = useAxios();
  const clientStore = useClientStore();

  const getClient = async ({ clientPath }: { clientPath: string }) => {
    try {
      const response = await api.get<ApiResponse<Client>>(EndPoint.clientPath, {
        params: { clientPath },
      });

      if (response.data) {
        clientStore.setClient(response.data);
        return response.data;
      }
    } catch (error) {
      console.error('Unable to get Client path.');
    }
  };

  return {
    getClient,
  };
};
export default useClient;
